import { render, staticRenderFns } from "./BrandCampaignTable.vue?vue&type=template&id=5bcae62c&"
import script from "./BrandCampaignTable.vue?vue&type=script&lang=js&"
export * from "./BrandCampaignTable.vue?vue&type=script&lang=js&"
import style0 from "./BrandCampaignTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports